import { pick } from '../../utils/moduleHelpers';

const toNum = (v, fallback = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};

export const formatMoney = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(toNum(value));

export const formatLots = (value) =>
  new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(toNum(value));

export const formatChallengeDate = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatChallengeDateTime = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/** Days/hours/minutes/seconds remaining until `target` (never negative). */
export const getCountdownParts = (target) => {
  const end = new Date(target).getTime();
  if (!Number.isFinite(end)) return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
  const diff = Math.max(0, end - Date.now());
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    expired: diff <= 0,
  };
};

/**
 * 'upcoming'  -> now < startDate            (show "Starting after")
 * 'active'    -> startDate <= now <= endDate (show "Ending after")
 * 'ended'     -> now > endDate
 */
export const getChallengePhase = (startDate, endDate, now = Date.now()) => {
  const start = new Date(startDate).getTime();
  const end = new Date(endDate).getTime();
  if (Number.isFinite(start) && now < start) return 'upcoming';
  if (Number.isFinite(end) && now > end) return 'ended';
  return 'active';
};

export const normalizeChallengeOverview = (row = {}) => {
  const startDate = pick(row, 'startDate', 'StartDate');
  const endDate = pick(row, 'endDate', 'EndDate');
  return {
    title: pick(row, 'title', 'Title') || 'Weekly Challenge',
    startDate,
    endDate,
    minimumLots: toNum(pick(row, 'minimumLots', 'MinimumLots')),
    commissionPerLot: toNum(pick(row, 'commissionPerLot', 'CommissionPerLot')),
    isActive: pick(row, 'isActive', 'IsActive') !== false,
    totalAccounts: toNum(pick(row, 'totalAccounts', 'TotalAccounts')),
    totalLots: toNum(pick(row, 'totalLots', 'TotalLots')),
    totalEarnings: toNum(pick(row, 'totalEarnings', 'TotalEarnings')),
  };
};

export const normalizeChallengeParticipant = (row = {}, index = 0) => {
  const lotsTrade = toNum(pick(row, 'lotsTrade', 'LotsTrade'));
  const progressPercent = Math.max(0, Math.min(100, toNum(pick(row, 'progressPercent', 'ProgressPercent'))));
  return {
    id: `${pick(row, 'userCode', 'UserCode') || 'row'}-${index}`,
    createdDateTime: pick(row, 'createdDateTime', 'CreatedDateTime'),
    userCode: pick(row, 'userCode', 'UserCode') || '—',
    accountNo: pick(row, 'accountNo', 'AccountNo') || '—',
    isDeposit: String(pick(row, 'isDeposit', 'IsDeposit') || 'No').toLowerCase() === 'yes',
    lotsTrade,
    remainingLots: toNum(pick(row, 'remainingLots', 'RemainingLots')),
    progressPercent,
    earnings: toNum(pick(row, 'earnings', 'Earnings')),
  };
};
